import { render, staticRenderFns } from "./AssignAttachmentTab.vue?vue&type=template&id=709e3cf6&scoped=true&"
import script from "./AssignAttachmentTab.vue?vue&type=script&lang=js&"
export * from "./AssignAttachmentTab.vue?vue&type=script&lang=js&"
import style0 from "./AssignAttachmentTab.vue?vue&type=style&index=0&id=709e3cf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709e3cf6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSpacer,VTextField})
